import type { AppModule } from '@shared/presentation/router/composition.js';
import { virtualProfilerAnalysisConfigModule } from './analysis-config/module.js';
import { virtualProfilerAnalysisGroupsModule } from './analysis-groups/module.js';
import { virtualProfilerEnginesModule } from './engines/module.js';
import { virtualProfilerOverviewModule } from './overview/module.js';
import { virtualProfilerAnalysisQueueModule } from './queue/module.js';
import { virtualProfilerUploadsModule } from './uploads/module.js';
import { virtualProfilerVideoDetailModule } from './video-detail/module.js';
import { virtualProfilerVideoDatasetModule } from './videos/module.js';

/**
 * `virtual-profiler` context: supervising and controlling the tool.
 *
 * Six features for the five screens of the epic — the video detail is the sixth
 * because it is reached from two of them and belongs to neither — plus the background
 * uploads, which have no screen and live in the shell's overlays. The engines'
 * changelog is a detail of the groups board, reached from its Motores card.
 *
 * Adding a feature to this context is one line here. The order is the one the
 * screens are meant to be used in. The module's own navigation lives in
 * `lib/vp-sections.ts`, not in the sidebar, which lists the module once.
 */
export const virtualProfilerModules: AppModule[] = [
  virtualProfilerOverviewModule,
  virtualProfilerAnalysisQueueModule,
  virtualProfilerVideoDatasetModule,
  virtualProfilerVideoDetailModule,
  virtualProfilerAnalysisGroupsModule,
  virtualProfilerEnginesModule,
  virtualProfilerAnalysisConfigModule,
  virtualProfilerUploadsModule,
];
